import pageHeader from "../components/pageHeader/locals/ar.json";
import aboutSection from "../components/aboutSection/locals/ar.json";

export default {
  pageHeader,
  aboutSection
};